import { Reducer } from 'redux'
import { SugarBloodState, SugarBloodActionTypes } from './type'

const initialState: SugarBloodState = {
  list: {},
  recent: [],
  history: {},
}

const reducer: Reducer<SugarBloodState> = (state = initialState, action) => {
  switch (action.type) {
    case SugarBloodActionTypes.INIT_SUGARBLOOD_SUCCESS: {
      const { data, patientId } = action;
      return {
        ...state,
        list: {
          ...state.list,
          [patientId]: data
        }
      }
    }
    case SugarBloodActionTypes.FETCH_SUGARBLOOD_RECENT_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        recent: data
      }
    }
    case SugarBloodActionTypes.FETCH_SUGARBLOOD_HISTORY_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        history: data
      }
    }
    default: {
      return state
    }
  }
}

export { reducer as SugarBloodReducer };